import { render, staticRenderFns } from "./GuestDocumentationLuxuryGold.vue?vue&type=template&id=5b2458b4&scoped=true&"
import script from "./GuestDocumentationLuxuryGold.vue?vue&type=script&lang=js&"
export * from "./GuestDocumentationLuxuryGold.vue?vue&type=script&lang=js&"
import style0 from "./GuestDocumentationLuxuryGold.vue?vue&type=style&index=0&id=5b2458b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2458b4",
  null
  
)

export default component.exports